import Vue from "vue";
import Vuex from "vuex";

import user from "./modules/user";
import config from "./modules/config";

import createLogger from "../plugins/logger";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  modules: {
    user: user,
    config: config
  },
  strict: debug,
  plugins: debug ? [createLogger()] : []
});
